import { Component } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { DeploysComponent } from '../deploys/deploys.component';
import { DevicesComponent } from '../devices/devices.component';
import { FirmwaresComponent } from '../firmwares/firmwares.component';
import { GroupsComponent } from '../groups/groups.component';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    MatTabsModule,
    DevicesComponent,
    GroupsComponent,
    FirmwaresComponent,
    DeploysComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {
  title = 'client';
  selectedIndex: number = 0; // Indice della tab selezionata
  login = false;

  constructor(private authService: AuthService, private dialog: MatDialog) {
    const token = this.authService.getToken();
    if (!token) {
      const dialogRef = this.dialog.open(LoginDialogComponent, {
        width: '300px',
        disableClose: true,
      });
    } else {
      this.login = true;
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
    // Esegui qualsiasi logica per inviare un evento al figlio, a seconda dell'indice
    console.log('Tab cambiata a indice: ', event.index);
  }
}

@Component({
  selector: 'app-login-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Accedi al sistema di update</h2>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="onLogin()">
        Login
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      h2 {
        text-align: center;
      }
    `,
  ],
})
export class LoginDialogComponent {
  onLogin() {
    window.location.href = environment.login;
  }
}
